import {downloadGeneratedImageAsset} from '@Components/ai-chat-window/lib/ai-chat-downloads.library';
import {sendPrompt} from '@Components/ai-chat-window/lib/ai-chat-prompt.library';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {ImageQualityOption} from '@Components/download-panel/components/ai-chat-image-download-panel-content/ai-chat-image-download-panel-content.types';
import type {ButtonAction} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {ButtonActionType, DownloadFileType, DownloadImageQuality} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {showPurchaseCreditsDialog} from '@Libraries/ai-chat.library';
import {openPremiumPricingModal} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import {NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource} from '@Libraries/ga-events';
import {refreshTeamCreditsInStore} from '@Components/team-credits/team-credits-library';
import {COOKIE_EXPIRY_30_MINUTES, setCookie} from '@Utils/cookie.util';

export const dispatchButtonAction = async (action: ButtonAction): Promise<void> => {
  switch (action.type) {
    case ButtonActionType.DOWNLOAD: {
      await downloadGeneratedImageAsset(action.chatId, action.hashedId, toQualityOption(action.imageQuality), toFileTypeOption(action.fileType));
      return;
    }
    case ButtonActionType.FILL_PROMPT: {
      sendPrompt(action.chatId, action.text);
      return;
    }
    case ButtonActionType.UPSELL_PREMIUM: {
      setCookie(NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource.AI_CHAT_AGENT_UPSELL, COOKIE_EXPIRY_30_MINUTES);
      openPremiumPricingModal(false, undefined, action.promoCode);
      return;
    }
    case ButtonActionType.UPSELL_CREDITS: {
      openCreditPackCheckout();
      return;
    }
  }
};

/** Fire-and-forget so the button never waits on a checkout the user can close without buying. */
const openCreditPackCheckout = (): void => {
  void showPurchaseCreditsDialog().then((purchaseData) => {
    if (!purchaseData?.creditsV2) {
      return;
    }

    void refreshTeamCreditsInStore();
  });
};

const toFileTypeOption = (fileType: DownloadFileType): FileTypeOptions => {
  if (fileType === DownloadFileType.PDF) {
    return FileTypeOptions.PDF;
  }

  return FileTypeOptions.PNG;
};

const toQualityOption = (quality: DownloadImageQuality): ImageQualityOption => {
  if (quality === DownloadImageQuality.ENHANCED_4K) {
    return ImageQualityOption.ENHANCED_4K;
  }

  return ImageQualityOption.ORIGINAL;
};
